import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import SchoolAddress from './SchoolAddress';
import BiographyNote from './BiographyNote';
import PermissionSplash from 'components/PermissionSplash';

export default class Personal extends React.Component {
	render() {
		let routeProps = this.props;
		const read = this.props.userRole !== undefined ? this.props.userRole.some(role => {
			return (role.section === 'School' && role.access_read === "1")
		}) : false
	if ((this.props.variant === 'admin' && read === true) || this.props.variant !== 'admin') {
			return (
				<Switch>
					<Route path="/portal/school/Transcript Address" render={() =>
						<SchoolAddress addressType="Transcript" rescoAddressType="2" {...routeProps} />
					} />
					<Route path="/portal/school/Invoice Address" render={() =>
						<SchoolAddress addressType="Invoice" rescoAddressType="I" {...routeProps} />
					} />
					<Route path="/portal/school/Biography Note" render={() => <BiographyNote {...routeProps} />} />
					<Route path="*" render={() => (
						<Redirect to="/portal/school/Transcript Address" />
					)} />
				</Switch>
			);
		} else {
			return (
				<div style={{margin: '40px'}}>
				<PermissionSplash />
				</div>

			);
		}
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/SchoolInformation/index.jsx